import React, { useState, useEffect } from 'react';
import './RightPanel.css';

function RightPanel({ 
  layers, 
  currentColor, 
  onColorChange, 
  onLayerVisibilityToggle, 
  onLayerSelect, 
  onAddLayer, 
  onRemoveLayer 
}) {
  // 기본 색상 팔레트
  const defaultColors = [
    '#ff0000', '#ff8800', '#ffff00', '#88ff00', '#00ff00', 
    '#00ff88', '#00ffff', '#0088ff', '#0000ff', '#8800ff',
    '#ff00ff', '#ff0088', '#ffffff', '#cccccc', '#888888', 
    '#444444', '#000000', '#442200', '#440000', '#004400'
  ];
  
  // 커스텀 팔레트 상태
  const [customPalette, setCustomPalette] = useState([]);
  
  // 로컬 스토리지에서 커스텀 팔레트 불러오기
  useEffect(() => {
    const savedPalette = localStorage.getItem('customPalette');
    if (savedPalette) {
      try {
        setCustomPalette(JSON.parse(savedPalette));
      } catch (e) {
        console.error('팔레트 불러오기 실패:', e);
      }
    }
  }, []);
  
  // 커스텀 팔레트 저장
  useEffect(() => {
    localStorage.setItem('customPalette', JSON.stringify(customPalette));
  }, [customPalette]);
  
  // 커스텀 팔레트에 색상 추가
  const addToCustomPalette = () => {
    // 이미 팔레트에 있는 색상이면 추가하지 않음
    if (!customPalette.includes(currentColor)) {
      setCustomPalette([...customPalette, currentColor]);
    }
  };
  
  // 커스텀 팔레트에서 색상 제거
  const removeFromCustomPalette = (colorToRemove) => {
    setCustomPalette(customPalette.filter(color => color !== colorToRemove));
  };

  return (
    <div className="right-panel">
      {/* 색상 팔레트 섹션 (상단으로 이동) */}
      <div className="panel-section palette-section">
        <div className="panel-header">
          <span>색상</span>
        </div>
        <div className="color-picker">
          <div 
            className="current-color" 
            style={{ backgroundColor: currentColor }}
          />
          <input 
            type="color" 
            className="color-input" 
            value={currentColor}
            onChange={(e) => onColorChange(e.target.value)}
          />
          <button 
            className="add-color-button" 
            title="커스텀 팔레트에 추가"
            onClick={addToCustomPalette}
          >
            +
          </button>
        </div>
        
        {/* 기본 팔레트 */}
        <div className="palette-section-header">기본 팔레트</div>
        <div className="custom-palette">
          {defaultColors.map((color, index) => (
            <div 
              key={`default-${index}`}
              className="palette-color"
              style={{ backgroundColor: color }}
              onClick={() => onColorChange(color)}
            />
          ))}
        </div>
        
        {/* 커스텀 팔레트 */}
        <div className="palette-section-header">
          커스텀 팔레트
          <span className="palette-help">(우클릭으로 삭제)</span>
        </div>
        <div className="custom-palette">
          {customPalette.length > 0 ? (
            customPalette.map((color, index) => (
              <div 
                key={`custom-${index}`}
                className="palette-color"
                style={{ backgroundColor: color }}
                onClick={() => onColorChange(color)}
                onContextMenu={(e) => {
                  e.preventDefault();
                  removeFromCustomPalette(color);
                }}
              />
            ))
          ) : (
            <div className="empty-palette-message">
              색상을 추가하려면 + 버튼을 클릭하세요
            </div>
          )}
        </div>
      </div>
      
      {/* 레이어 섹션 (하단으로 이동) */}
      <div className="panel-section layers-section">
        <div className="panel-header">
          <span>레이어</span>
        </div>
        <div className="layers-list">
          {layers.map(layer => (
            <div 
              key={layer.id}
              className={`layer-item ${layer.active ? 'active' : ''}`}
              onClick={() => onLayerSelect(layer.id)}
            >
              <span 
                className="layer-visibility"
                onClick={(e) => {
                  e.stopPropagation();
                  onLayerVisibilityToggle(layer.id);
                }}
              >
                {layer.visible ? '◉' : '○'}
              </span>
              <span className="layer-name">{layer.name}</span>
            </div>
          ))}
        </div>
        <div className="layer-controls">
          <button 
            className="layer-control-button" 
            title="레이어 추가"
            onClick={onAddLayer}
          >
            +
          </button>
          <button 
            className="layer-control-button" 
            title="레이어 삭제"
            onClick={onRemoveLayer}
          >
            −
          </button>
          <button 
            className="layer-control-button" 
            title="레이어 이름 변경"
          >
            ✎
          </button>
        </div>
      </div>
    </div>
  );
}

export default RightPanel;